"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonTabDropdown = void 0;
var React = _interopRequireWildcard(require("react"));
var _react2 = require("@floating-ui/react");
var _lodash = require("lodash");
var _space = require("../../styles/variables/_space");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _clickAway = require("../../utils/click-away");
var _mergeRefs = require("../../utils/merge-refs");
var _Menu = require("../Menu");
var _ButtonTab = require("./ButtonTab");
var _ButtonTabDropdownModule = _interopRequireDefault(require("./ButtonTabDropdown.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ButtonTabDropdown = _ref => {
  let {
    title,
    anchorPosition = 'bottom-end',
    ...buttonTabProps
  } = _ref;
  const menuBtnRef = React.useRef();
  const {
    size,
    children,
    selectedButtonTabId,
    onButtonTabSelect: onTabSelect,
    dropdownClass
  } = buttonTabProps;
  const childrenArray = React.Children.toArray(children);
  const menuOptions = childrenArray.map(child => {
    const {
      id,
      children,
      disabled,
      iconName,
      iconType,
      classNames,
      size: buttonSize
    } = child.props;
    return {
      key: id,
      disabled,
      classNames,
      label: children,
      iconLeft: iconName,
      iconLeftType: iconType,
      customComponent: children,
      optionSize: buttonSize ?? size
    };
  });
  const moreTabSelectedId = (0, _lodash.includes)(menuOptions.map(_ref2 => {
    let {
      key
    } = _ref2;
    return key;
  }), selectedButtonTabId) ? 'more-tab' : selectedButtonTabId;
  const {
    x,
    y,
    refs,
    strategy
  } = (0, _react2.useFloating)({
    open: true,
    strategy: 'absolute',
    placement: anchorPosition,
    whileElementsMounted: _react2.autoUpdate,
    middleware: [(0, _react2.shift)(), (0, _react2.flip)(), (0, _react2.offset)(parseInt(_space.spaceXXSmall))]
  });
  return /*#__PURE__*/React.createElement(_clickAway.ClickAway, null, _ref3 => {
    let {
      isOpen,
      onOpen,
      clickAway,
      boundaryRef,
      triggerRef
    } = _ref3;
    return /*#__PURE__*/React.createElement("div", {
      "data-testid": "ButtonTabDropdown",
      ref: menuBtnRef,
      className: (0, _classify.default)(_ButtonTabDropdownModule.default.buttonTabDropDownWrapper, dropdownClass)
    }, /*#__PURE__*/React.createElement(_ButtonTab.ButtonTab, _extends({}, buttonTabProps, {
      ref: (0, _mergeRefs.mergeRefs)([refs.setReference, triggerRef]),
      selectedButtonTabId: moreTabSelectedId,
      onButtonTabSelect: (id, e) => {
        e?.stopPropagation();
        onOpen();
      }
    }), title), isOpen && /*#__PURE__*/React.createElement("div", {
      ref: (0, _mergeRefs.mergeRefs)([refs.setFloating, boundaryRef]),
      style: {
        display: 'flex',
        position: strategy,
        top: y ?? _space.spaceNone,
        left: x ?? _space.spaceNone
      }
    }, /*#__PURE__*/React.createElement(_Menu.Menu, {
      onSelect: (option, e) => {
        onTabSelect && onTabSelect(option.key, e);
        clickAway();
      },
      size: size,
      options: menuOptions,
      onTabOut: clickAway,
      selectedKeys: [selectedButtonTabId ?? '']
    })));
  });
};
exports.ButtonTabDropdown = ButtonTabDropdown;